import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthenticationService } from '@app/auth/services/authentication.service';
import { SubNavService } from '@app/menu/services/sub-nav.service';
import { RouterService } from '@app/routing/router.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'portal-sub-nav',
  templateUrl: './sub-nav.component.html',
  standalone: false,
})
export class SubNavComponent implements OnInit {
  /**
   * If this is true, the sub nav will always be displayed.
   */
  @Input()
  public force: boolean = false;

  /**
   * Show the sub nav if the specified route matches the current route.
   */
  @Input()
  public route?: string;

  @Output()
  public visibleChanged = new EventEmitter<boolean>();

  public show: boolean = false;

  private update = () => {
    this.show = this.force !== false || this.routerService.currentRouteMatches(this.route);

    if (this.route != null && this.force === false) {
      this.subNavService.toggle(this.route, this.show);
    }

    this.visibleChanged.emit(this.show);
  };

  constructor(
    private authenticationService: AuthenticationService,
    private routerService: RouterService,
    private subNavService: SubNavService
  ) {}

  public ngOnInit() {
    if (this.route != null) {
      this.update();

      this.routerService.routeChanged$.pipe(untilDestroyed(this)).subscribe(() => {
        if (this.authenticationService.isAuthenticated) {
          this.update();
        }
      });
    }
  }
}
